export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <div className="card__description-title">Загальна характеристика</div>
                <p className="card__description-text">
                    ФЛЕШ — це гібрид для тих, хто хоче максимально швидкий результат. Його ключова фішка — ультраранній розвиток, що дозволяє гнучко працювати зі строками посіву та зменшувати ризики, пов’язані з погодними умовами.
                </p>
                <p className="card__description-text">
                    Це ідеальний варіант для регіонів, де важлива швидкість, стабільність і здатність “втекти” від стресу.
                </p>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Чому варто обрати ФЛЕШ
                    </p>
                    <li className="card__description-numbering">Потенціал урожайності — до 4,9 т/га</li>
                    <li className="card__description-numbering">Стійкість до вовчка — A–G+</li>
                    <li className="card__description-numbering">Висока посухостійкість і жаростійкість</li>
                    <li className="card__description-numbering">Гнучкість у строках посіву</li>
                    <li className="card__description-numbering">Потужна коренева система</li>
                    <li className="card__description-numbering">Швидкий старт і активний розвиток на початку вегетації</li>
                </ol>
                <div className="card__description-title">Основні показники</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        ФЛЕШ добре показує себе у:
                    </p>
                    <li className="card__description-numbering">Степу</li>
                    <li className="card__description-numbering">Лісостепу</li>
                    <li className="card__description-numbering">Поліссі</li>
                </ol>
                <p className="card__description-text">
                    Особливо ефективний у зонах із нестабільними погодними умовами, де важлива швидка вегетація.
                </p>
                <div className="card__description-title">Поведінка в полі</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Енергія стартового росту — висока (9/10)</li>
                    <li className="card__description-numbering">Посухостійкість — 9/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання — 8/10</li>
                </ol>
                <p className="card__description-text">
                    Гібрид добре тримає стрес і швидко відновлюється після несприятливих умов.
                </p>
                <div className="card__description-title">Практичні рекомендації</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        ФЛЕШ — це класичний екстенсивний гібрид, який:
                    </p>
                    <li className="card__description-numbering">не потребує надвисокого агрофону</li>
                    <li className="card__description-numbering">добре працює в “середніх” умовах</li>
                    <li className="card__description-numbering">дозволяє варіювати строки посіву</li>
                </ol>
                <p className="card__description-text">
                    Рекомендовано застосування гербіцидів системи SUMO® для контролю бур’янів.
                </p>
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Енергiя початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Посухостiйкiсть</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Стiйкiсть до вилягання</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                </div>
                <div className="card__description-title">ФЛЕШ — це про швидкість і гнучкість. Його варто пропонувати клієнтам, які:</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">бояться посухи</li>
                    <li className="card__description-numbering">хочуть ранній урожай</li>
                    <li className="card__description-numbering">працюють у ризикованих регіонах</li>
                </ol>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Гнучкість у термінах посіву завдяки ультраранньому вегетаційному періоду</div>
                    <div className="aside__block">Висока посухостійкість та жаростійкість</div>
                    <div className="aside__block">Гібрид екстенсивного типу з швидкими темпами росту на початкових етапах</div>
                </div>
            </div>
        </div>
    );
}
